import { gql } from "@/gql/__generated__";
import { Get_Organization_InvitationQuery } from "@/gql/__generated__/graphql";
import { useQuery } from "@apollo/client";

export const GET_ORGANIZATION_INVITATION = gql(`
  query GET_ORGANIZATION_INVITATION($invitationId: ID!) {
    organizationInvitation(invitationId: $invitationId) {
      __typename
      ... on OrganizationInvitation {
        id
        role
        email
        organizationName
      }
      ... on OrganizationInvitationNotFound {
        id
      }
      ... on OrganizationNotFound {
       id
       slug
      } 
    }
  }
`);

type Props = {
  invitationId: string;
};

export const useGetOrganizationInvitation = ({ invitationId }: Props) => {
  const result = useQuery(GET_ORGANIZATION_INVITATION, {
    variables: { invitationId }
  });
  return result;
};

export type OrganizationInvitationType = Extract<
  Get_Organization_InvitationQuery["organizationInvitation"],
  { __typename: "OrganizationInvitation" }
>;

export type OrganizationInvitationErrorTypes = Exclude<
  Get_Organization_InvitationQuery["organizationInvitation"],
  { __typename: "OrganizationInvitation" }
>;
